// Utility for reviewBtnClickHandler logic
const reviewBtnClickHandlerUtil = ({
    dispatch,
    setProcedureData,
    procedureInfoData,
    vendorCaseId,
    usageDetails,
    myCaseResourceType,
    updateDiscrepancyReport,
    showReportPayment,
    reportPaymentGridData,
    myCaseRefId,
    getRPValidateItemsArr,
    validateProductDetails,
    setFilteredProduct,
    setProgressBarStatus,
    currentActivity,
    REPORTPROGRESSTEPS,
    getModifiedButtonVisibilities,
    footerButtonStatuses,
    review,
    submit,
    setFooterButtonStatuses,
    setShowReportPayment,
    showUnidInfoScreen,
    unidSurgeryInfo,
    storeUnidSurgeryLocalState,
    validateMazorCodeRes,
    validateMazorKitCodeOnCTAbtnClick,
    replenGridData,
    procedurePageVisibility,
    setIsProcedureBtnClicked,
    setShowCancelPopUp,
    screenSwitchOnReviewBtnClick,
    setCurrentActivity,
    replenishmentPageVisibilityUsage
}) => {
    dispatch(setProcedureData(procedureInfoData));
        if (
            (vendorCaseId?.startsWith('SE_') ||
                vendorCaseId?.startsWith('MT_')) &&
            usageDetails?.products?.length > 0 &&
            myCaseResourceType === 'draft'
        ) {
            updateDiscrepancyReport();
        }
        if (showReportPayment) {
            if (reportPaymentGridData.length > 0 && myCaseRefId) {
                const validateItemsArr = getRPValidateItemsArr(
                    reportPaymentGridData
                );
                const validateItemsObj = {
                    myCaseRef: myCaseRefId,
                    products: validateItemsArr,
                };
                dispatch(validateProductDetails(validateItemsObj, false));
            } else if (reportPaymentGridData.length === 0) {
                setFilteredProduct([]);
                dispatch(setProgressBarStatus(currentActivity));
                setCurrentActivity(
                    REPORTPROGRESSTEPS[
                    REPORTPROGRESSTEPS.findIndex(
                        (activity) => activity === currentActivity
                    ) + 1
                    ]
                );
                const modifiedButtonStatuses = getModifiedButtonVisibilities(
                    myCaseResourceType,
                    footerButtonStatuses,
                    review,
                    submit
                );
                setFooterButtonStatuses(modifiedButtonStatuses);
                setShowReportPayment(false);
            }
        } else {
            if (showUnidInfoScreen && Object.keys(unidSurgeryInfo).length > 0) {
                storeUnidSurgeryLocalState();
            }
            if (
                !usageDetails?.unidId &&
                validateMazorCodeRes?.statusCode === 'draft'
            ) {
                validateMazorKitCodeOnCTAbtnClick('review');
            } else if (
                replenGridData.some(
                    (data) =>
                        data.isSelected &&
                        !data.shippingDetails &&
                        !data.accountOwned
                ) &&
                !procedurePageVisibility && replenishmentPageVisibilityUsage
            ) {
                setIsProcedureBtnClicked(true);
                setShowCancelPopUp(true);
            } else {
                screenSwitchOnReviewBtnClick();
            }
        }
    };


export default reviewBtnClickHandlerUtil;
